import { NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { BaryCardsSelectorComponent } from '../../../components/bary-cards-selector/bary-cards-selector.component';
import { BaryInputCheckboxComponent } from '../../../components';

import { CardsTypeSelector } from '../../../../../models/cards-type-selector';
import { OfferMerchandiseTypeEnum } from '../../../../../models/enums/offer-merchandise-type.enum';
import { OfferServiceTypeEnum } from '../../../../../models/enums/offer-service-type.enum';

@Component({
  selector: 'jhi-bary-offer-form',
  standalone: true,
  imports: [TranslateModule, BaryInputCheckboxComponent, BaryCardsSelectorComponent, NgIf],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './bary-offer-form.component.html',
})
export class BaryOfferFormComponent {
  @Input() isOffer: boolean = true; // Si le composant est utilisé sur une offre ou une estimation
  @Input() formGroup!: FormGroup;

  protected readonly CONDITIONED = OfferMerchandiseTypeEnum.CONDITIONED;
  protected readonly OFFER_MERCHANDISE_TYPE = CardsTypeSelector.OFFER_MARCHANDISE_TYPE;
  protected readonly SERVICE_TYPE = CardsTypeSelector.SERVICE_TYPE;

  public getFormControl(name: string): FormControl {
    return this.formGroup.get(name) as FormControl;
  }

  public updateForm(value: any): void {
    if (OfferMerchandiseTypeEnum.UNCONDITIONED === value) {
      this.formGroup.get('serviceType')?.setValue(OfferServiceTypeEnum.FTL);
    }
  }
}
